import { useEffect } from "react";
import siteConfig from "../config/siteConfig";

const Seo = ({ title, description = siteConfig.description }) => {
  useEffect(() => {
    document.title = title ? `${title} | ${siteConfig.brandName}` : siteConfig.metaTitle;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description);
  }, [title, description]);
  return null;
};

export default Seo;
